import React from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { Row, Col, Badge, UncontrolledTooltip } from 'reactstrap';

function Card ({ laudo, showPreview }) {
  const intl = useIntl()
  return (
    <Row style={{ marginTop: '16px' }} className='teste'>
      <Col style={{ marginTop: '-18px' }}>
        <p
					id={`paciente_${laudo.laudoId}`}
					style={{ fontSize: '14px', marginBottom: '2px' }}
				>
					<strong>{`${intl.formatMessage({id:"dashboards.general.pacient"}) }`}:</strong>
					{laudo.paciente}
						<UncontrolledTooltip placement='top' target={`paciente_${laudo.laudoId}`}>
							{laudo.paciente}
						</UncontrolledTooltip>
				</p>
				{laudo.pacienteNomeSocial &&
					<p
						id={`nomesocial_${laudo.laudoId}`}
						style={{ fontSize: '14px', marginBottom: '2px' }}
					>
						<strong>{`${intl.formatMessage({id:"dashboards.reports.socialName"}) }`}:</strong>
						{laudo.pacienteNomeSocial}
							<UncontrolledTooltip placement='top' target={`nomesocial_${laudo.laudoId}`}>
								{laudo.pacienteNomeSocial}
							</UncontrolledTooltip>
					</p>}

        {laudo.nrExame && (
          <p style={{ fontSize: '14px', marginBottom: 0 }}>
            <strong>{`${intl.formatMessage({id:"dashboards.general.examNumber"}) }`}:</strong> {laudo.nrExame}
          </p>
        )}
  
        <Badge color='primary' className='badge-reagente'>
          <Badge color='link'>{laudo.etapa}</Badge>
          <Badge color='dark'>{laudo.tipo}</Badge>
        </Badge>
      </Col>
      <Col>
        {laudo.dataEntrega && (
          <p
            style={{ position: 'absolute', right: '19px', fontSize: '10px' }}
            className='badge badge-info'
            title={`${intl.formatMessage({id:"dashboards.general.expectedDelivery"}) }`}
          >
            {new Date(laudo.dataEntrega).toLocaleString()}
          </p>
        )}
        <Row>
          <div className='menu-card' style={{ right: '-10px' }}>
            <Link to={`laudo/${laudo.laudoId}`}>
              <i
                title={`${intl.formatMessage({id:"dashboards.doctorTasks.reportDetails"}) } ${
                  laudo.nrExame ? laudo.nrExame : ''
                }`}
                style={{ marginRight: '8px' }}
                className='mv-basico-detalhes'
              ></i>
            </Link>
            <i
              style={{ marginRight: '8px' }}
              className='fas fa-search'
              title='Preview'
              onClick={() => showPreview(laudo)}
            ></i>
          </div>
        </Row>
      </Col>
    </Row>
  );
}

export default Card;



// WEBPACK FOOTER //
// ./src/pages/tarefas/Card/index.js